import { render, staticRenderFns } from "./preview-header.vue?vue&type=template&id=45d7590e&"
import script from "./preview-header.vue?vue&type=script&lang=js&"
export * from "./preview-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports